import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeManualInput extends Shape {
    width = 200;
    height = 156;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width - 2 * horizontalPadding;
        const allowedHeight = (height * 4) / 5 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY =
            y +
            height / 5 +
            this.getTextLineHeight(textPart) +
            (height * 4) / 5 / 2 -
            textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        let r = height / 30;

        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + height / 5 + r);
        canv.ctx.arcTo(x, y + height / 5, x + width, y, r);
        canv.ctx.arcTo(x + width, y, x + width, y + height, r);
        canv.ctx.arcTo(x + width, y + height, x, y + height, r);
        canv.ctx.arcTo(x, y + height, x, y, r);
        canv.ctx.lineTo(x, y + height / 5 + r);
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="M2.20589 3.62992L2.2059 3.62992L22.2059 0.523249C23.3943 0.338648 24.5 1.29281 24.5 2.58946V16.4111C24.5 17.5814 23.5882 18.5 22.5 18.5H2.5C1.41175 18.5 0.5 17.5814 0.5 16.4111V5.69614C0.5 4.64819 1.23827 3.78022 2.20589 3.62992Z"/>
            </svg>
        `;
    }
}
